/**
 * What the reminder components read from a reminder: the store's reminders
 * (reminderSlice) and the older copies saved in localStorage, which carry
 * the note inline and a completion time where newer ones have `true`.
 */
export interface ShownReminder {
  id?: number;
  due?: number | string | null;
  completed?: boolean | number | string | null;
  note?: { title?: string; text?: string } | null;
}

/**
 * `new Date(value)` for a reminder's due or completed field, as Date reads
 * it: a boolean or null counts as its number, a missing value is an invalid
 * date.
 */
export function toDate(value: ShownReminder["due" | "completed"]): Date {
  if (value === undefined) return new Date(NaN);
  if (value === null || typeof value === "boolean") {
    return new Date(Number(value));
  }
  return new Date(value);
}
